/**
 * BDY-CTRL: Product card interactions
 *
 * 1. HOVER IMAGE REVEAL — image area only
 *    Adds/removes .card--img-hovered on the card wrapper when the cursor
 *    enters/leaves the .card__inner image box. CSS uses that class to reveal
 *    the secondary image — scoped to the photo, not the whole card.
 *
 * 2. COLOUR SWATCH CLICK → card image swap only
 *    Swaps the primary image to the clicked colour's variant image and
 *    toggles the active swatch. Does NOT rewrite product title links —
 *    rewriting caused every card to open one PDP when product_url / variant
 *    URLs collapsed to the same href (combined listings, option context).
 */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────────────────────
     1. HOVER IMAGE — add / remove .card--img-hovered
     Uses mouseover/mouseout with bubble detection so it works on
     dynamically rendered cards (sliders, infinite scroll, etc.)
     ───────────────────────────────────────────────────────────── */

  document.addEventListener('mouseover', function (e) {
    var inner = e.target.closest('.card__inner');
    if (!inner) return;
    var wrapper = inner.closest('.product-card-wrapper');
    if (wrapper) wrapper.classList.add('card--img-hovered');
  });

  document.addEventListener('mouseout', function (e) {
    var inner = e.target.closest('.card__inner');
    if (!inner) return;
    var wrapper = inner.closest('.product-card-wrapper');
    if (!wrapper) return;
    /* Only remove when the cursor truly leaves card__inner, not just
       moves between child elements inside it */
    if (!inner.contains(e.relatedTarget)) {
      wrapper.classList.remove('card--img-hovered');
    }
  });

  /* ─────────────────────────────────────────────────────────────
     2. COLOUR SWATCH CLICK → swap card image
     ───────────────────────────────────────────────────────────── */

  function swapCardImage(swatch) {
    var wrapper = swatch.closest('.product-card-wrapper');
    if (!wrapper) return;

    /* Swap primary image */
    var src    = swatch.dataset.variantMediaSrc;
    var srcset = swatch.dataset.variantMediaSrcset;
    var alt    = swatch.dataset.variantMediaAlt;

    if (src) {
      var primaryImg = wrapper.querySelector('[data-card-primary-image]');
      if (primaryImg) {
        primaryImg.src = src;
        if (srcset) primaryImg.srcset = srcset;
        if (alt)    primaryImg.alt    = alt;
      }
    }

    /* Swap hover image if variant-specific hover data is provided */
    var hoverSrc    = swatch.dataset.variantHoverSrc;
    var hoverSrcset = swatch.dataset.variantHoverSrcset;
    if (hoverSrc) {
      var hoverImg = wrapper.querySelector('[data-card-hover-image]');
      if (hoverImg) {
        hoverImg.src = hoverSrc;
        if (hoverSrcset) hoverImg.srcset = hoverSrcset;
      }
    }

    /* Toggle active swatch highlight */
    wrapper.querySelectorAll('.card__color-swatch').forEach(function (s) {
      s.classList.remove('card__color-swatch--active');
    });
    swatch.classList.add('card__color-swatch--active');
  }

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.card__color-swatch');
    if (!swatch) return;
    swapCardImage(swatch);
  });

})();
